/*
 *==================================================
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2021
 *
 *==================================================
 */
export const spacing = 8;
export const colors = {
  blue: "#8A000B",
};

export const size = {
  xs: "320px",
  sm: "425px",
  md: "768px",
  lg: "1024px",
  xl: "1440px",
};

export const deviceWidths = {
  xs: `(min-width: ${size.xs})`,
  sm: `(min-width: ${size.sm})`,
  md: `(min-width: ${size.md})`,
  lg: `(min-width: ${size.lg})`,
  xl: `(min-width: ${size.xl})`,
};
